import React from "react";
import CopyToClipboard from "images/clipboardcopy.svg";
import XIcon from "images/x.png";
import Link from "helpers/link";
import { shopURL, mystablesUrl } from "utils/constants";
import OgrLogo from "images/ogr-small-logo.jpeg";

export const Image = ({ image }) => <img src={image} alt="Coupon" className="w-full h-full object-cover" />

export const Button = ({ text, onClick }) => <button onClick={onClick} className="btn btn-primary ml-auto !font-extralight mt-8 sm:mt-4"> {text} </button>

export const CloseModal = ({ onClick }) => (
  <button onClick={onClick} className="absolute w-4 h-4 top-4 right-4 cursor-pointer">
    <img src={XIcon} alt="Close Modal" />
  </button>
)

export const ConfirmModalContent = ({ coupon, onGoBack }) => {
  const { slug, code } = coupon;
  const link = `${shopURL}/coupon/${slug}`;

  return (
    <div className="bg-white flex flex-col w-[600px] h-[400px] justify-center items-center m-auto rounded-2xl relative">
      <CloseModal onClick={onGoBack} />
      <h2 className="text-2xl font-bold sm:text-base text-green-700 w-fit mb-4"> Here it is! </h2>
      <div className="flex gap-1 mb-8">
        <div className="bg-gray-300 px-8 w-fit text-gray-700 font-light flex justify-center items-center">
          {code}
        </div>
        <button
          className="bg-green-700 p-2"
          onClick={() => navigator.clipboard.writeText(code)}
        >
          <img src={CopyToClipboard} alt="Copy to Clipboard" className="w-8 h-8" />
        </button>
      </div>
      <Link to={link} className="text-white bg-green-700 py-2 px-12 rounded sm:text-xs"> Visit site </Link>
    </div>
  )
}

export const CouponModalContent = ({ coupon, onClose, onNext }) => {
  const { description, name, validity, image } = coupon;

  return (
    <>
      <div className="absolute z-0 w-full h-full" onClick={onClose} />
      <div className="flex my-auto flex-col relative z-100">
        <CloseModal onClick={onClose} />
        <div className="h-[240px] md:h-[180px] sm:h-[120px] rounded-t-2xl overflow-hidden">
          <img src={image.src} alt="Coupon" className="w-full h-full object-cover" />
        </div>
      <div className="flex flex-col bg-white px-20 md:px-8 sm:px-6 py-14 md:py-8 sm:py-4 rounded-b-2xl overflow-hidden">
        <div className="flex items-center mb-12 md:mb-8 sm:mb-4">
          <img className="w-10 h-10 mr-4 rounded-full" src={OgrLogo} alt="Old Gold Racing Logo" />
          <p className="font-montserrat text-[19px] text-gray-700 font-medium"> Old Gold Racing </p>
        </div>
        <div className="flex sm:flex-col font-montserrat">
          <div className="flex flex-col pr-12 md:pr-8 sm:pr-4 w-1/2 sm:w-full justify-between">
            <div className="flex flex-col mb-20 md:mb-12 sm:mb-4">
              <h2 className="text-4xl md:text-2xl sm:text-base font-bold text-gray-700"> {name} </h2>
              <p className="text-yellow-400 mb-6 sm:mb-2 sm:text-sm font-bold"> Validity: {validity} Months </p>
              <p className="sm:text-xs font-normal text-gray-700">{description}</p>
            </div>
            <Link to="/terms" className="text-green-700 w-fit sm:text-xs font-montserrat font-normal paragraph-with-underline after:text-green-700"> Terms & Conditions </Link>
          </div>
          <div className="flex flex-row sm:flex-col w-1/2 sm:w-full sm:pt-4">
            <div className="bg-[#F6F6F6] w-1 sm:w-full sm:h-1" />
            <div className="flex flex-col items-start justify-between pl-12 md:pl-6 sm:pl-0">
              <div className="flex flex-col">
                <h2 className="text-green-700 font-bold text-4xl md:text-2xl sm:text-base mb-4 font-display"> Claim this offer </h2>
                <p className="mb-10 sm:mb-4 sm:text-sm font-montserrat font-normal text-gray-700"> To claim this offer and others like it, join the Old Gold Racing Club for free! </p>
              </div>
              <button 
                className="btn btn-primary !px-4 !py-3 !font-normal sm:text-xs !font-montserrat !mb-4"
                onClick={onNext}
              > 
                Join the Club & Claim Offer
              </button>
              <Link to={`${mystablesUrl}/`} className="paragraph-with-underline cursor-pointer text-green-700 after:text-green-700 sm:text-xs">
                If you are an Old Gold Racing owner, you already have access to this benefit. Click here to log in and claim it.
              </Link>
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  )
}
